module.exports = __webpack_public_path__ + "media/images/help/line/eyecatch-point-2-1013d23fa14effb20ffa4958806d7b7c.jpg";